export const TYPE_PDP_TOP = 'buyTogetherWith'
export const TYPE_PDP_CENTER = 'sliderAvailable'
export const TYPE_PDP_NA = 'sliderOutOfStock'
export const TYPE_PDP_AV = 'sliderNoSuccessor'
export const TYPE_PDP_RX = 'sliderForPrescriptedMedicine'
export const TYPE_START_PAGE = 'startPage'
export const TYPE_START_PAGE_BOTTOM = 'startPageBottom'
export const TYPE_CATEGORY = 'category'
export const TYPE_ADD_TO_CART_TOP = 'addToCartTop' // popular products
export const TYPE_ADD_TO_CART_CENTER = 'addToCartCenter' // recommended products
export const TYPE_CART_TOP = 'cartTop'
export const TYPE_CART_BOTTOM = 'cartBottom'
export const TYPE_NU3_ADD_TO_CART_BOTTOM = 'nu3AddToCartBottom'
export const TYPE_HOME = 'home'
export const TYPE_SEARCH_NO_RESULTS = 'sliderNoSearchResults'

export const CROSSSELL_CLASSNAME = 'crosssell-widget'
export const CROSSSELL_ATTR_ANALYTICS_NAME = 'crosssell-widget'
export const ANALYTICS_ATTR_IMAGE = 'item-image'
export const ANALYTICS_ATTR_TITLE = 'item-title'

export const DEFAULT_WIDGETS = {
  [TYPE_PDP_AV]: 71,
  [TYPE_PDP_NA]: 19,
  [TYPE_PDP_CENTER]: 18,
  [TYPE_PDP_RX]: 218,
  [TYPE_PDP_TOP]: 11,
  [TYPE_START_PAGE]: 2,
  [TYPE_START_PAGE_BOTTOM]: 20,
  [TYPE_CATEGORY]: 3,
  [TYPE_ADD_TO_CART_TOP]: 21,
  [TYPE_ADD_TO_CART_CENTER]: 22,
  [TYPE_CART_TOP]: 23,
  [TYPE_CART_BOTTOM]: 24,
  [TYPE_NU3_ADD_TO_CART_BOTTOM]: 68,
  [TYPE_HOME]: 2,
  [TYPE_SEARCH_NO_RESULTS]: 69
}
